import { render, staticRenderFns } from "./ModulePendenciesOpened.vue?vue&type=template&id=7c5d27ff"
import script from "./ModulePendenciesOpened.vue?vue&type=script&lang=js"
export * from "./ModulePendenciesOpened.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports